import React, {useState} from 'react'
import * as libphonenumber from 'libphonenumber-js'
import styled from 'styled-components'
import TextfieldAtom from '../textfield/textfield.atom'
import StackAtom from '../../to_layout/stack/stack.atom'
import phone_numberStyles from './phone_number.styles'

const apAtomName = {ap_atom_name: 'phoneNumberAtom'}

const StyleWrapper = styled.div`
  ${phone_numberStyles}
`

const PhoneNumberAtom = function () {
  const [countryCode, setCountryCode] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [error, setError] = useState('')
  const handleCountryCodeChange = (event: {
    target: {value: React.SetStateAction<string>}
  }) => {
    setCountryCode(event.target.value)
    if (event.target.value.length === 0)
      setError('Please enter valid phone number')
  }

  const handlePhoneNumberChange = (event: {
    target: {value: React.SetStateAction<string>}
  }) => {
    setPhoneNumber(event.target.value)
    if (event.target.value.length === 0)
      setError('Please enter valid phone number')
  }

  const handleBlur = () => {
    let countrycode = countryCode
    if (countryCode.substring(0, 1) !== '+') {
      countrycode = `+${countryCode}`
    }
    const phoneNumberWithCode = `${countrycode}${phoneNumber}`
    const result =
      libphonenumber.parsePhoneNumberFromString(phoneNumberWithCode)
    setPhoneNumber(result?.formatNational() || '')
    const res1 = result?.isValid()
    if (!res1) {
      setError('Please enter valid phone number')
    } else {
      setError('')
    }
  }

  return (
    <StyleWrapper {...apAtomName}>
      <StackAtom
        ap_type="row"
        className="phonenumber-atom"
        justifyContent="space-between"
      >
        <div className="country-code">
          <TextfieldAtom
            type="text"
            label="CC"
            value={countryCode}
            onChange={handleCountryCodeChange}
            error={!!error}
          />
        </div>

        <div className="phone-number">
          <TextfieldAtom
            type="text"
            label="phone number"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            error={!!error}
            helperText={error}
            onBlur={handleBlur}
          />
        </div>
      </StackAtom>
    </StyleWrapper>
  )
}
export default PhoneNumberAtom
